import { configureStore, createSlice } from '@reduxjs/toolkit';

// Create a dummy slice to avoid the "Store does not have a valid reducer" error
const dummySlice = createSlice({
  name: 'dummy',
  initialState: {},
  reducers: {}
});

// Create the store with our dummy reducer
const store = configureStore({
  reducer: {
    dummy: dummySlice.reducer
    // Add more reducers here as we develop features
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
